module.exports = __webpack_public_path__ + "static/submit-grad-mi-be204151b2c3532e2aedb162c5e6b964.png";